import React, { useEffect } from 'react';

declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element) => void;
    };
  }
}

const TrustpilotWidget: React.FC = () => {
  useEffect(() => {
    // Try to load the widget when the component mounts
    const loadWidget = () => {
      const element = document.getElementsByClassName('trustpilot-widget')[0];
      if (window.Trustpilot && element) {
        window.Trustpilot.loadFromElement(element);
      }
    };

    // First attempt
    loadWidget();

    // Retry a few times in case the script hasn't loaded yet
    const retryInterval = setInterval(() => {
      if (window.Trustpilot) {
        loadWidget();
        clearInterval(retryInterval);
      }
    }, 500);

    // Clean up
    return () => clearInterval(retryInterval);
  }, []);

  return (
    <div
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="6782579f7de5c0d9d1cab227"
      data-style-height="44px"
      data-style-width="100%"
      data-theme="light"
      data-stars="4,5"
      data-review-languages="en"
    >
      <a
        href="https://www.trustpilot.com/review/crjmc.net"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotWidget; 